<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <div class="left_tree">
        <el-tree ref="depTree" :data="frameTree" :accordion="true" :props="defaultProps" :expand-on-click-node="false"
          :default-expanded-keys="defaultExpandedKeys" class="tree_1" highlight-current node-key="id"
          @current-change="currentOrgChangeHandler">
          <template #default="{ data, node }">
            <span :style="{ 'padding-right': node.level > 1 ? '35px' : '0' }" class="left_tree_item"
              style="display: flex; align-items: center; position: relative">
              <img :src="getIcon(node.level)" style="margin-right: 6px" alt="" />
              <span :title="data.name" class="textAll">{{ data.name }}</span>
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    <div class="bottom_right">
      <div class="right_table">
        <el-table :data="folderTable" border :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          :expand-row-keys="expandRowKeys" highlight-current-row row-key="folderID" height="100%"
          @expand-change="expandChange">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              暂无数据
            </p>
          </template>
          <el-table-column label="文件夹名称" prop="folderName" min-width="200px" />
          <el-table-column label="备注" prop="folderNameCn" min-width="200px" />
          <el-table-column label="文件夹类型" min-width="200px">
            <template #default="{ row }">
              <span v-if="row.folderType == 99">系统文件夹</span>
              <span v-else>用户文件夹</span>
            </template>
          </el-table-column>
          <el-table-column label="创建人" prop="operUserName" min-width="200px">
            <template #default="{ row }">
              <div :title="`${row.operUserName}（${row.phoneNum}）`">
                {{ row.operUserName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="operDate" min-width="200px" />
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import templateDirectory from "@/CommonDP/service/templateDirectory-service";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
import { storage } from '@/CommonDP/utils';

export default {
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      defaultProps: {
        children: "children",
        label: "name"
      },
      frameTree: [], // 树
      defaultExpandedKeys: [],
      folderTable: [],
      expandRowKeys: []
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },
  created() {
    this.getFrameTree();
    storage.remove("TemplateID1");
  },
  methods: {
    // 获取左侧模板
    getFrameTree() {
      this.frameTree = [];
      templateDirectory.getTree(this.enterpriseId).then(({ data }) => {
        const array = data;
        for (const item of array) {
          if (item.children && item.children.length > 0) {
            item.children = item.children.map((a) => {
              return {
                name: a.folderName,
                id: a.templateID,
                ...a
              };
            });
            this.frameTree.push(item);
          } else {
            this.frameTree.push(item);
          }
        }
      });
    },
    // 选中节点
    currentOrgChangeHandler(val) {
      this.expandRowKeys = [];
      if (!val.isSpec) this.selectFolder(val.id);
    },

    // 查询文件夹
    selectFolder(val) {
      this.folderTable = [];
      templateDirectory.selectFolder(val, 0).then(({ data }) => {
        this.folderTable = data.folder || [];

        if (!this.expandRowKeys.length) {
          this.expandRowKeys = data.folderIDList || [];
        }
      });
    },

    expandChange({ folderID }, expanded) {
      if (expanded) {
        this.expandRowKeys.push(folderID);
      } else {
        const index = this.expandRowKeys.findIndex((id) => id === folderID);
        if (index > 0) this.expandRowKeys.splice(index, 1);
      }
    },
    getIcon(level) {
      if (level === 1) return require("@/CommonDP/assets/doc/folderParent.png");
      return require("@/CommonDP/assets/doc/folderChild.png");
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 42px;
$middle-height: 30px;
$left-width: 256px;
.bottom_tree_table {
  height: 100%;
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  min-width: 1050px;
  .bottom_left {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: $left-width;
    border-right: 1px solid #ebefff;
    .left_button {
      padding: 13px;
    }
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 3px;
      top: $top-button-height + 20px;
      bottom: 10px;
      right: 0;
      .tree_1 {
        font-size: 14px;
      }
      &_item {
        &_btn {
          position: absolute;
          right: 5px;
          visibility: hidden;
          i {
            cursor: pointer;
          }
        }

        &:hover {
          .left_tree_item_btn {
            visibility: visible;
          }
        }
      }
    }
    .textAll {
      width: 150px;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .bottom_right {
    position: relative;
    margin-left: $left-width + 10px;
    height: 100%;

    .right_button {
      height: $top-button-height;
      padding: 13px;
    }
    .right_table {
      position: absolute;
      top: 59px;
      left: 10px;
      bottom: 40px;
      right: 20px;
      .el-table {
        height: 100%;
        overflow: auto;
      }

      .el-button {
        padding: 0 !important;
        line-height: 1 !important;
        font-size: 20px;
      }
      .el-button + .el-button {
        margin-left: 5px;
      }
      ::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
        td:first-child {
          padding-left: 23px;
        }
      }
    }
  }
}

/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
}
</style>
